import React, { FormEvent } from 'react'
import { TwButton } from '../../components/Button/TwButton'
import { TextInput } from '../LoginPage/TextInput'
import { API } from '../../services/api'
import { History } from 'history'
import { AddAlbumForm, Container } from './styled'
import { mobileBreakpoint } from '../../theme'
import { RouteComponentProps } from 'react-router'
import { PageContent } from '../../components/Common/PageContent'
import { inject } from 'mobx-react'
import { WORKSPACES_STORE } from '../../stores'
import { WorkspacesStore } from '../../stores/WorkspaceStore'

interface AddAlbumPageProps extends RouteComponentProps<{ workspaceSlug: string }> {
  history: History
  [WORKSPACES_STORE]: WorkspacesStore
}

const _AddAlbumPage: React.FC<AddAlbumPageProps> = (props) => {
  const workspacesStore = props[WORKSPACES_STORE]
  const workspaceId = workspacesStore.activeWorkspaceId
  const workspaceSlug = workspacesStore.activeWorkspaceSlug

  const [state, setValues] = React.useState({
    loading: false,
    isPublic: false,
    name: '',
    description: '',
    error: '',
  })

  const setState = (newValues: Partial<typeof state>) =>
    setValues((state) => ({
      ...state,
      ...newValues,
    }))

  const handleChange =
    (prop: keyof typeof state) =>
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setState({ ...state, [prop]: event.target.value })
    }

  const handleCreateAlbum = async (e: FormEvent) => {
    e.preventDefault()

    const { name, description, isPublic } = state

    if (!name) {
      setState({ error: 'Nazwa albumu jest wymagana.' })
      return
    }
    setState({ loading: true })

    const response = await API.getInstance().createAlbum({
      workspaceId,
      name,
      description,
      isPublic,
    })

    if (response.ok === true) {
      props.history.replace(`/${workspaceSlug}/albums`)
    } else {
      setState({ error: response.data.message })
    }
  }

  const size = document.body.offsetWidth
  const isMobile = size < mobileBreakpoint.width

  return (
    <PageContent maxWidth="max-w-xl">
      <Container>
        <AddAlbumForm
          $isMobile={isMobile}
          noValidate
          autoComplete="off"
          onSubmit={handleCreateAlbum}
        >
          <h1 className={`mb-2 mt-2 font-bold text-gray-900 ${isMobile ? 'text-xl' : 'text-2xl'}`}>
            Stwórz album
          </h1>
          <p className="mb-1 text-sm text-gray-500">Trzymaj zdjecia w ryzach.</p>
          <TextInput
            label="Nazwa"
            value={state.name}
            onChange={handleChange('name')}
            error={Boolean(state.error)}
            helperText={`${state.name.length}/60`}
            disabled={state.loading}
            maxLength={60}
          />
          <TextInput
            multiline
            rows={6}
            label="Opis"
            value={state.description}
            onChange={handleChange('description')}
            error={Boolean(state.error)}
            helperText={state.error ? state.error : `${state.description.length}/255`}
            disabled={state.loading}
            maxLength={255}
          />
          <TwButton
            type="submit"
            variant="outline"
            size="md"
            disabled={state.loading}
            className="w-full mt-4"
          >
            Stwórz album
          </TwButton>
        </AddAlbumForm>
      </Container>
    </PageContent>
  )
}

export const AddAlbumPage = inject(WORKSPACES_STORE)(_AddAlbumPage) as React.FC<any>
